/* eslint-disable react/prop-types */
import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Formik } from 'formik';
import toastr from 'toastr';

import { connect } from 'react-redux';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';

import { updateTablet, getTablet } from '../api/tablet';

import { fetchTablets } from '../redux/actions/tablet';

import Content from '../components/layout/Content';
import SpinnerButton from '../components/buttons/SpinnerButton';
import Loading from '../components/Loading';


class TabletDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spinnerLoading: false,
      sweetAlert: false,
      shutDownAlert: false,
      enteredValues: null,
    };
  }

  async componentDidMount() {
    const { match: { params: { tabletId } } } = this.props;
    const getData = async (id) => {
      const data = await getTablet(id);
      const { tablet } = data.data;
      return tablet;
    };
    const tablet = await getData(tabletId);

    this.setState({ tablet });
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }


  render() {
    const {
      spinnerLoading, sweetAlert, tablet, paymentTypes, shutDownAlert, deliveryTypes, enteredValues,
    } = this.state;
    const { intl } = this.props;
    const { locale } = intl;
    const test = '';

    const tabletDetailText = intl.formatMessage({ id: 'tablet.detail' });
    const tabletStatusText = intl.formatMessage({ id: 'tablet.status' });
    const tabletConnectionText = intl.formatMessage({ id: 'tablet.connection_' });
    const tabletNameText = intl.formatMessage({ id: 'tablet.name' });
    const isTabletBusyText = intl.formatMessage({ id: 'tablet.busy' });
    const tabletSettingPasswordText = intl.formatMessage({ id: 'tablet.settingPassword' });
    const tabletPaymentTypesText = intl.formatMessage({ id: 'tablet.paymentTypes' });
    const tabletDeliveryTypesText = intl.formatMessage({ id: 'tablet.deliveryTypes' });
    const tabletIPText = intl.formatMessage({ id: 'tablet.ip' });
    const tabletHostnameText = intl.formatMessage({ id: 'tablet.hostname' });
    const tabletMacAddressText = intl.formatMessage({ id: 'tablet.macaddress' });
    const tabletScreenResolutionText = intl.formatMessage({ id: 'tablet.screenresolution' });
    const homeText = intl.formatMessage({ id: 'sidebar.menu.home' });
    const savedText = intl.formatMessage({ id: 'saved' });
    const startTextText = intl.formatMessage({ id: 'tablet.startText' });
    const startTextPositionText = intl.formatMessage({ id: 'tablet.startTextPosition' });
    const topText = intl.formatMessage({ id: 'top' });
    const centerText = intl.formatMessage({ id: 'center' });
    const bottomText = intl.formatMessage({ id: 'bottom' });
    const entityNameText = intl.formatMessage({ id: 'tablet.entityName' });
    const fieldNameText = intl.formatMessage({ id: 'field.name' });
    const fieldValueText = intl.formatMessage({ id: 'field.value' });
    const restartText = intl.formatMessage({ id: 'restart' });
    const shutdownText = intl.formatMessage({ id: 'shutdown' });
    const restartItText = intl.formatMessage({ id: 'restart.it' });
    const shutdownItText = intl.formatMessage({ id: 'shutdown.it' });
    const areYouSureText = intl.formatMessage({ id: 'areyousure' });
    const tabletWillRestartText = intl.formatMessage({ id: 'restart.will' });
    const tabletWillShutdownText = intl.formatMessage({ id: 'shutdown.will' });
    const entityTypeText = intl.formatMessage({ id: 'tablet.entityType' });
    const currencyNameText = intl.formatMessage({ id: 'tablet.currencyText' });
    const tabletStrategy = intl.formatMessage({ id: 'tablet.usageStrategy' });
    return (
      <Content title={tabletDetailText} breads={[{ to: '/panel', name: homeText }, { name: tabletDetailText }]}>
        {
          !tablet
            ? <Loading />
            : (
              <Formik
                initialValues={{
                  displayName: tablet.displayName || tablet.ipAddress,
                  startText: tablet.startText,
                  startTextPosition: tablet.startTextPosition,
                  tabletPassword: (tablet.tabletPassword || ''),
                  entityName: tablet.entityName,
                  entityType: tablet.entityType,
                  strategy: tablet.strategy,
                  currency: tablet.currency,
                }}
                enableReinitialize
                onSubmit={async (values) => {
                  const { match: { params: { tabletId } }, dispatch } = this.props;
                  this.setState({ spinnerLoading: true });

                  await updateTablet({
                    tabletId,
                    tablet: {
                      displayName: values.displayName,
                      startText: values.startText,
                      startTextPosition: values.startTextPosition,
                      tabletPassword: values.tabletPassword,
                      entityName: values.entityName,
                      entityType: values.entityType,
                      strategy: values.strategy,
                      currency: values.currency,
                    },
                  });

                  dispatch(fetchTablets());
                  this.setState({ spinnerLoading: false });
                  toastr.success('', savedText);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                  /* and other goodies */
                }) => (
                  <Form onSubmit={handleSubmit}>

                      <FormGroup>
                        <Label>{tabletNameText}</Label>
                        <Input
                          type="text"
                          name="displayName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.displayName}
                        />
                        {errors.email && touched.email && errors.email}
                      </FormGroup>
                      <FormGroup>
                        <Label>{startTextText}</Label>
                        <Input
                          type="text"
                          name="startText"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.startText}
                        />
                        {errors.email && touched.email && errors.email}
                      </FormGroup>
                      <FormGroup>
                        <Label>{tabletSettingPasswordText}</Label>
                        <Input
                          type="number"
                          name="tabletPassword"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.tabletPassword}
                        />
                        {errors.email && touched.email && errors.email}
                      </FormGroup>
                      <FormGroup>
                        <Label>{currencyNameText}</Label>
                        <Input
                          type="text"
                          name="currency"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.currency}
                        />
                        {errors.email && touched.email && errors.email}
                      </FormGroup>
                      <FormGroup>
                        <Label for="exampleSelect">{tabletStrategy}</Label>
                        <Input
                          type="select"
                          name="strategy"
                          id="strategy"
                          onChange={handleChange}
                          defaultValue={values.strategy}
                        >
                          <option value="table">Table first- Dynamic Tablet</option>
                          <option value="order">Order first - Dynamic Tablet</option>
                          <option value="free">Free to use - Static Tablet</option>
                        </Input>
                      </FormGroup>
                      <FormGroup>
                        <Label>{entityTypeText}</Label>
                        <Input
                          type="text"
                          name="entityType"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.entityType}
                        />
                        {errors.email && touched.email && errors.email}
                      </FormGroup>
                      <FormGroup>
                        <Label>{entityNameText}</Label>
                        <Input
                          type="text"
                          name="entityName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.entityName}
                        />
                        {errors.email && touched.email && errors.email}
                      </FormGroup>
                      <FormGroup>
                        <Label for="exampleSelect">{startTextPositionText}</Label>
                        <Input
                          type="select"
                          name="startTextPosition"
                          id="startTextPosition"
                          onChange={handleChange}
                          defaultValue={values.startTextPosition}
                        >
                          <option value="top">{topText}</option>
                          <option value="center">{centerText}</option>
                          <option value="bottom">{bottomText}</option>
                        </Input>
                      </FormGroup>


                      <FormGroup>
                        <Label>{tabletIPText}</Label>
                        <Input
                          type="text"
                          name="ipAddress"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={tablet.ipAddress}
                          disabled
                        />
                        {errors.email && touched.email && errors.email}
                      </FormGroup>
                      <FormGroup>
                        <Label>{tabletHostnameText}</Label>
                        <Input
                          type="text"
                          name="hostName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={tablet.hostName}
                          disabled
                        />
                        {errors.email && touched.email && errors.email}
                      </FormGroup>
                      <FormGroup>
                        <Label>{tabletMacAddressText}</Label>
                        <Input
                          type="text"
                          name="macAddress"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={tablet.macAddress}
                          disabled
                        />
                        {errors.email && touched.email && errors.email}
                      </FormGroup>

                      <StatusWrapper>
                        <SpinnerButton type="submit" loading={spinnerLoading} text="Save" />

                      </StatusWrapper>

                    </Form>

                )}
              </Formik>
            )
        }
      </Content>
    );
  }
}

const CircleWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 0;
`;

const Circle = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? 'green' : 'red')};
  margin-left: 10px;
`;

const StatusWrapper = styled.div`
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

const mapStateToProps = (state, dispatch) => ({
  tablets: state.tablets,
  user: state.auth.user,
  dispatch,
});

export default injectIntl(connect(mapStateToProps)(TabletDetail));
